import SignalBadIcon from '@/assets/icons/Signal-Bad.svg'
import SignalGoodIcon from '@/assets/icons/Signal-Good.svg'
import SignalGoodMarginalIcon from '@/assets/icons/Signal-GoodMarginal.svg'
import SignalMarginalIcon from '@/assets/icons/Signal-Marginal.svg'
import SignalMarginalBadIcon from '@/assets/icons/Signal-MarginalBad.svg'
import { formatSignalResult } from '@/features/jobs/lib/format-signal-result'
import type { AntennaSignalResult } from '@/features/jobs/types/job-detail'

const signalResultIcons: Record<AntennaSignalResult, string> = {
  good: SignalGoodIcon,
  good_marginal: SignalGoodMarginalIcon,
  marginal: SignalMarginalIcon,
  marginal_bad: SignalMarginalBadIcon,
  bad: SignalBadIcon,
}

type SignalResultValueProps = {
  signalResult: AntennaSignalResult
}

export const SignalResultValue = ({ signalResult }: SignalResultValueProps) => (
  <span className="inline-flex items-center gap-2">
    <img
      src={signalResultIcons[signalResult]}
      alt=""
      aria-hidden
      className="h-4 w-auto"
    />
    {formatSignalResult(signalResult)}
  </span>
)
